<h1 mat-dialog-title>Terms & Conditions</h1>
<div mat-dialog-content>
  <div class="customer-service-area ptb-100">
    <div class="container">
      <div class="customer-service-content">
        <b>These terms and conditions (the "Terms and Conditions") govern the use of <u><a href="www.scanfluence.com"
              target="_blank">www.scanfluence.com</a></u> (the
          "Site"). This Site is owned and operated by Scanfluence Software Inc. Ontario, Canada.</b>
        <br>
        <br>
        <h3>User Agreement</h3>
        <p>By using this Site, you indicate that you have read and understand these Terms and Conditions and agree
          to abide by them at all times. These Terms of use constitute a legally binding agreement between you and
          the Scanfluence Software Inc. by clicking 'I agree' you agree to be bound by these terms.</p>

        <h3>Intellectual Property</h3>
        <p>All content published and made available on our Site is the property of Scanfluence Software Inc. and the
          Site's creators. This includes, but is not limited to images, text, logos, documents, downloadable files
          and anything that contributes to the composition of our Site.</p>

        <h3>Age Restrictions</h3>
        <p>The minimum age to use our Site is 18 years old. By using this Site, users agree that they are over 18
          years old. We do not assume any legal responsibility for false statements about age.</p>

        <h3>Acceptable Use</h3>
        <p>As a user of our Site, you agree to use our Site legally, not to use our Site for illegal purposes, and
          not to:</p>

        <ul>
          <li>Harass or mistreat other users of our Site;</li>
          <li>Violate the rights of other users of our Site;</li>
          <li>Violate the intellectual property rights of the Site owners or any third party to the Site;</li>
          <li>Hack into the account of another user of the Site;</li>
          <li>Act in any way that could be considered fraudulent;</li>
          <li>Post any material that may be deemed inappropriate or offensive; or</li>
          <li>Transmit computer viruses that could affect other users.</li>
        </ul>

        <p>If we believe you are using our Site illegally or in a manner that violates these Terms and Conditions,
          we reserve the right to limit, suspend or terminate your access to our Site. We also reserve the right
          to take any legal steps necessary to prevent you from accessing our Site.</p>


        <h3>User Contributions</h3>
        <p>Registered Users may post the following information on our Site: Product and services on offer. You agree
          to ensure that all information, descriptions, or images about goods and services are accurate and do not
          indulge in misinformation. By posting publicly, you agree not to act illegally or violate these Terms
          and Conditions.</p>

        <h3>Accounts</h3>
        <p>When you create an account on our Site, you agree to the following:</p>

        <p><strong>1.</strong> You are solely responsible for your account and the security and privacy of your
          account, including passwords or sensitive information attached to that account; and<br>
          <strong>2.</strong> All personal information you provide to us through your account is up to date,
          accurate, and truthful and that you will update your personal information if it changes.<br>
        </p>

        <p>We reserve the right to suspend or terminate your account if you are using our Site illegally or if you
          violate these Terms and Conditions.</p>


        <h3>Sale of Goods And Services available on our Site</h3>

        <ul>
          <li>Campaign management Software As A Service (SAAS)</li>
          <li>Campaign Generator</li>
          <li>Code generator</li>
          <li>Single use coupon codes</li>
          <li>Digital Frequent buyer reward plan generator</li>
          <li>Track Campaign performance</li>
          <li>Secured coupon validation</li>
          <li>Reconciliation of redeemed coupons</li>
        </ul>

        <p>The services will be paid for in full when the services are ordered.</p>

        <p>We reserve the right to modify, reject or cancel your order whenever it becomes necessary. If we cancel
          your order and have already processed your payment, we will give you a refund equal to the amount you
          paid. You agree that it is your responsibility to monitor your payment instrument to verify receipt of
          any refund.</p>

        <h3>Third Party Goods and Services</h3>
        <p>Our Site may offer goods and services from third parties. We cannot guarantee the quality or accuracy of
          goods and services made available by third parties on our Site.</p>

        <h3>User Goods and Services</h3>
        <p>Our Site allows registered users to create and publish coupons and promotional offers. We do not assume
          any responsibility for the goods and services users sell on our Site. We cannot guarantee the quality or
          accuracy of any goods and services sold by users on our Site. However, if we are made aware that a user
          is violating these Terms and Conditions, we reserve the right to suspend or prohibit the user from
          selling goods and services on our Site.</p>

        <h3>Subscriptions</h3>
        <p>Your subscription automatically renews and you will be automatically billed until we receive notification
          that you want to cancel the subscription.</p>

        <p>To cancel your subscription, please follow these steps: A subscriber may cancel their Subscription
          Service Agreement at any time. A email request for termination of services must be submitted to
          servicedesk@scanfluence.com . The subscriber will be liable for payment of all services rendered during
          the subscription period.</p>

        <h3>Payments</h3>
        <p>We accept the following payment methods on our Site:</p>

        <ul>
          <li>Credit Card;</li>
          <li>PayPal;</li>
          <li>Debit; and</li>
          <li>Direct Debit</li>
        </ul>

        <p>When you provide us with your payment information, you authorize our use of and access to the payment
          instrument you have chosen to use. By providing us with your payment information, you authorize us to
          charge the amount due to this payment instrument.</p>

        <p>If we believe your payment has violated any law or these Terms and Conditions, we reserve the right to
          cancel or reverse your transaction.</p>


        <h3>Consumer Protection Law</h3>
        <p>Where the Consumer Protection Act, or any other consumer protection legislation in your jurisdiction
          applies
          and cannot be excluded, these Terms and Conditions will not limit your legal rights and remedies under
          that
          legislation. These Terms and Conditions will be read subject to the mandatory provisions of that
          legislation. If there is a conflict between these Terms and Conditions and that legislation, the
          mandatory
          provisions of the legislation will apply.</p>

        <h3>Links to Other Websites</h3>
        <p>Our Site contains links to third party websites or services that we do not own or control. We are not
          responsible for the content, policies, or practices of any third party website or service linked to on
          our
          Site. It is your responsibility to read the terms and conditions and privacy policies of these third
          party
          websites before using these sites.</p>

        <h3>Limitation of Liability</h3>
        <p> Scanfluence Software Inc. and our directors, officers, agents, employees, subsidiaries, and affiliates
          will
          not be liable for any actions, claims, losses, damages, liabilities and expenses including legal fees
          from
          your use of the Site.</p>

        <h3>Indemnity</h3>
        <p>Except where prohibited by law, by using this Site you indemnify and hold harmless Scanfluence Software
          Inc.
          and our directors, officers, agents, employees, subsidiaries, and affiliates from any actions, claims,
          losses, damages, liabilities and expenses including legal fees arising out of your use of our Site or
          your
          violation of these Terms and Conditions.</p>

        <h3>Applicable Law</h3>
        <p>These Terms and Conditions are governed by the laws of the Province of Ontario.</p>

        <h3>Dispute Resolution</h3>
        <p>Subject to any exceptions specified in these Terms and Conditions, if you and Scanfluence Software Inc.
          are
          unable to resolve any dispute through informal discussion, then you and Scanfluence Software Inc. agree
          to
          submit the issue first before a non-binding mediator and to an arbitrator in the event that mediation
          fails.
          The decision of the arbitrator will be final and binding. Any mediator or arbitrator must be a neutral
          party
          acceptable to both you and Scanfluence Software Inc..</p>

        <p>Notwithstanding any other provision in these Terms and Conditions, you and Scanfluence Software Inc.
          agree
          that you both retain the right to bring an action in small claims court and to bring an action for
          injunctive relief or intellectual property infringement.</p>

        <h3>Severability</h3>
        <p>If at any time any of the provisions set forth in these Terms and Conditions are found to be inconsistent
          or
          invalid under applicable laws, those provisions will be deemed void and will be removed from these Terms
          and
          Conditions. All other provisions will not be affected by the removal and the rest of these Terms and
          Conditions will still be considered valid.</p>

        <h3>Changes</h3>
        <p>These Terms and Conditions may be amended from time to time in order to maintain compliance with the law
          and
          to reflect any changes to the way we operate our Site and the way we expect users to behave on our Site.
          We
          will notify users by email of changes to these Terms and Conditions or post a notice on our Site.
        <p>

        <h3> Contact Details</h3>
        <p>Please contact us if you have any questions or concerns. Our contact details are as follows:</p>

        <p><u>compliance@scanfluence.com</u></p>
        <p>125 EAST AVENUE</p>
        <p>You can also contact us through the feedback form available on our Site.</p>

        <br>
        <p>Effective Date: 27th day of March, 2023</p>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="center">
  <button mat-button mat-flat-button color="primary" [mat-dialog-close]="false">Close</button>
</div>